import React from 'react';
import { Table, Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { createTableColumns } from '../utils/archivedFormsUtils';
import ActionButtons from './ActionButtons';

/**
 * Arşivlenmiş formlar tablosu
 */
const ArchivedFormsTable = ({ 
  data, 
  loading, 
  onRestore, 
  onDelete,
  onPreview,
  tableConfig 
}) => {
  const { t } = useTranslation();

  // Tablo sütunlarını oluştur
  const getColumns = createTableColumns({
    onRestore,
    onDelete,
    onPreview,
    ActionButtonsComponent: ActionButtons
  });

  const columns = getColumns(t);

  // Boş durum komponenti
  const emptyComponent = (
    <Empty
      image={<InboxOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />}
      description={t('no_archived_forms')}
    />
  );

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      locale={{ emptyText: emptyComponent }}
      {...tableConfig}
    />
  );
};

export default ArchivedFormsTable;
